const root = process.env.REACT_APP_API_GRAPHQL;
const mainMenuRoute =  root + '?query={secciondeMenu{seccionSitio{contentItems{displayText ... on Opciondemenu{displayText rutadestino icono{urls} descripcion{html}}}}}}';

export default mainMenuRoute;